// extracted by mini-css-extract-plugin
module.exports = {"logo":"DevLogo_logo__SFJJ5"};